var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"courseA"},[_c('div',{staticClass:"courseAPdf"},_vm._l((_vm.numPages),function(i){return _c('pdf',{key:i,attrs:{"src":_vm.pdfUrl,"page":i}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }